<template>
  <div class="list row">
    <div class="col-md-8 mr-4">
      <div class="input-group mb-3">
        <input type="text" v-validate="'required|min:1|max:75'" class="form-control mr-2" placeholder="Search by name" v-model="name"/>
        <div class="input-group-append">
          <button class="btn btn-outline-secondary" type="button" @click="page = 1; retrieveCountries();"><font-awesome-icon icon="search" /> Search</button>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <button class="btn btn-primary" @click="newCountry"><font-awesome-icon icon="plus" /> Add Country</button>
    </div>
    <div class="col-md-12 hgap"></div>
    <div class="col-md-6">
      <h4><font-awesome-icon icon="list-alt" /> Countries List</h4>
      <ul class="list-group">
        <li class="list-group-item" :class="{ active: index == currentIndex }" v-for="(country, index) in countries" :key="index"  @click="setActiveCountry(country, index)">
          {{ country.name }}
        </li>
      </ul>
      <div class="col-md-12 hgap"></div>
      <div v-if="loading" class="justify-content-center">
        <font-awesome-icon icon="spinner" /> <span>Loading...please wait</span>
      </div>
      <table class="table table-borderless">
        <tr>
          <td>
            <div class="d-flex justify-content-center">
              Items per Page:
              <select v-model="pageSize" @change="handlePageSizeChange($event)">
                <option v-for="size in pageSizes" :key="size" :value="size">
                  {{ size }}
                </option>
              </select>
            </div>
          </td>
          <td>
            <div class="d-flex justify-content-end">
              <b-pagination v-model="page" :total-rows="count" :per-page="pageSize" prev-text="Prev" next-text="Next" @change="handlePageChange"></b-pagination>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <div class="col-md-6">
      <div v-if="currentCountry">
        <h4><font-awesome-icon icon="info-circle" /> Country Details</h4>
        <table class="table">
        <tr>
          <td><strong>Code:</strong></td><td> {{ currentCountry.code }}</td>
        </tr>
        <tr>
          <td><strong>Name:</strong></td><td> {{ currentCountry.name }}</td>
        </tr>
        </table>

        <!-- <a class="m-3 btn btn-sm btn-warning" :href="'/countries/' + currentCountry.id"><font-awesome-icon icon="edit" /> Edit </a>-->
        <router-link :to="{ path: '/countries/' + currentCountry.id }" class="m-3 btn btn-sm btn-warning"><font-awesome-icon icon="edit" /> Edit </router-link>
      </div>
      <div v-else>
        <br />
        <p>Please click on a Country...</p>
      </div>
    </div>
  </div>
</template>

<script>
import CountryService from "../services/country.service";

export default {
  name: "countries-list",
  data() {
    return {
      countries: [],
      currentCountry: null,
      currentIndex: -1,
      name: "",

      page: 1,
      count: 0,
      pageSize: 5,
      pageSizes: [5, 10, 15, 20, 25],
      loading: false
    };
  },
  methods: {
    /*retrieveCountries() {
      CountryService.getAll()
        .then(response => {
          this.countries = response.data;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },*/

    retrieveCountries() {
      this.loading = true;
      if (this.page) {
        this.page = this.page - 1;
      }
      CountryService.getAllPageable(this.name, this.page, this.pageSize)
        .then(response => {
          const { countries, totalItems } = response.data;
          this.countries = countries;
          this.count = totalItems;
          this.loading = false;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },

    handlePageChange(value) {
      this.page = value;
      this.retrieveCountries();
    },

    handlePageSizeChange(event) {
      this.pageSize = event.target.value;
      this.page = 1;
      this.retrieveCountries();
    },

    refreshList() {
      this.retrieveCountries();
      this.currentCountry = null;
      this.currentIndex = -1;
    },

    setActiveCountry(country, index) {
      this.currentCountry = country;
      this.currentIndex = index;
    },

    removeAllCountries() {
      CountryService.deleteAll()
        .then(response => {
          console.log(response.data);
          this.refreshList();
        })
        .catch(e => {
          console.log(e);
        });
    },
    
    /*searchName() {
      CountryService.getByName(this.name)
        .then(response => {
          this.countries = response.data;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },*/

    newCountry() {
      this.$router.push('/addcountry');
    }
  },
  mounted() {
    this.retrieveCountries();
  }
};
</script>

<style>
.list {
  text-align: left;
  max-width: 100%;
  margin: auto;
  margin-top: 3.2em;
}
.paginate{
  margin-top: 1.7em;
}
.hgap{
  clear: both;
  margin-top: 1.1em;
}
</style>